import { TrendingUp, TrendingDown, Minus, ChevronLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { cur } from '@/lib/currency';

function fmt(n, decimals = 0) {
  return Number(n || 0).toLocaleString('ar-EG', { minimumFractionDigits: decimals, maximumFractionDigits: decimals });
}

function KpiCard({ label, value, trend, trendLabel, color = 'primary', suffix = cur(), loading, to }) {
  const navigate = useNavigate();
  if (loading) return (
    <div className="bg-card border border-border rounded-2xl p-4 min-w-36 flex-shrink-0 animate-pulse h-24" />
  );
  const up = trend > 0;
  const down = trend < 0;
  const tColor = up ? 'text-emerald-600' : down ? 'text-red-500' : 'text-muted-foreground';
  const clickable = !!to;

  return (
    <div
      onClick={clickable ? () => navigate(to) : undefined}
      className={`bg-card border border-border rounded-2xl p-4 min-w-36 flex-shrink-0 space-y-1 relative transition-all duration-200
        ${clickable ? 'cursor-pointer hover:border-primary hover:shadow-md hover:-translate-y-0.5 active:scale-[0.98]' : ''}`}
    >
      {clickable && (
        <ChevronLeft className="absolute top-3 left-3 w-3.5 h-3.5 text-primary opacity-50 group-hover:opacity-100" />
      )}
      <p className="text-xs text-muted-foreground font-medium leading-tight">{label}</p>
      <p className="text-xl font-black text-foreground leading-none">
        {value} <span className="text-xs font-medium text-muted-foreground">{suffix}</span>
      </p>
      {trend !== undefined && (
        <div className={`flex items-center gap-0.5 text-xs font-semibold ${tColor}`}>
          {up ? <TrendingUp className="w-3 h-3" /> : down ? <TrendingDown className="w-3 h-3" /> : <Minus className="w-3 h-3" />}
          {trend > 0 ? '+' : ''}{trend}% {trendLabel || 'عن السابق'}
        </div>
      )}
    </div>
  );
}

export default function KpiStrip({ kpis, loading }) {
  return (
    <div className="flex gap-3 overflow-x-auto no-scrollbar pb-1">
      {kpis.map((k, i) => (
        <KpiCard key={i} {...k} loading={loading} />
      ))}
    </div>
  );
}